import React from 'react';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';

export const productImages = [
  "/PHOTO-2025-10-12-20-37-31.jpg",
  "/PHOTO-2025-10-12-20-37-40.jpg",
  "/PHOTO-2025-10-12-20-37-56.jpg",
  "/PHOTO-2025-10-12-20-38-05.jpg",
  "/PHOTO-2025-10-12-20-38-13.jpg",
  "/PHOTO-2025-10-12-20-38-19.jpg",
  "/PHOTO-2025-10-12-20-38-34.jpg",
  "/PHOTO-2025-10-12-20-38-41.jpg",
  "/PHOTO-2025-10-12-20-39-35.jpg",
  "/PHOTO-2025-10-12-20-41-11.jpg",
  "/PHOTO-2025-10-12-20-41-53.jpg",
  "/PHOTO-2025-10-12-20-44-13.jpg",
  "/PHOTO-2025-10-12-20-48-14.jpg",
  "/PHOTO-2025-10-12-20-49-05.jpg",
  "/PHOTO-2025-10-12-20-49-40.jpg",
  "/PHOTO-2025-10-12-20-50-14.jpg",
  "/PHOTO-2025-10-12-20-50-33.jpg",
  "/PHOTO-2025-10-12-20-51-00.jpg",
  "/PHOTO-2025-10-12-20-51-44.jpg",
  "/PHOTO-2025-10-12-20-56-31.jpg",
  "/PHOTO-2025-10-12-20-58-31.jpg"
];

export const products = [
  { id: 1, title: "Matrix Mega Sleek Shampoo 300ml", image: productImages[0], alt: "Matrix Mega Sleek Shampoo", price: 290, description: "A shea butter–infused anti-frizz shampoo. Cleanses while helping control unruly hair and defrizz in humid environments." },
  { id: 2, title: "Matrix Mega Sleek Conditioner 300ml", image: productImages[1], alt: "Matrix Mega Sleek Conditioner", price: 290, description: "Works in tandem with the shampoo: smooths hair, adds slip, and continues to fight frizz and humidity." },
  { id: 3, title: "Matrix Mega Sleek Blow Down Smoothing Leave In Cream 150ml", image: productImages[2], alt: "Matrix Mega Sleek Blow Down Smoothing Leave In Cream", price: 360, description: "A leave-in styling cream designed to smooth and protect hair during blow-drying." },
  { id: 4, title: "Matrix Mega Sleek Iron Smoother 250ml", image: productImages[3], alt: "Matrix Mega Sleek Iron Smoother", price: 360, description: "A smoothing spray / formula to be used before (or during) flat ironing to enhance sleekness and reduce frizz under heat." },
  { id: 5, title: "Matrix Food For Soft Hydrating Shampoo 300ml", image: productImages[4], alt: "Matrix Food For Soft Hydrating Shampoo", price: 320, description: "A hydrating shampoo that cleanses while moisturizing dry hair. It delivers up to 7× more moisture for up to 72 hours when used in the full Food For Soft system." },
  { id: 6, title: "Matrix Food For Soft Detangling Hydrating Conditioner 300ml", image: productImages[5], alt: "Matrix Food For Soft Detangling Hydrating Conditioner", price: 320, description: "A conditioner that helps detangle, smooth, and replenish moisture in dry or brittle hair. Works in tandem with the shampoo to leave hair soft and manageable." },
  { id: 7, title: "Matrix Food For Soft Rich Hydrating Treatment Mask 500ml", image: productImages[6], alt: "Matrix Food For Soft Rich Hydrating Treatment Mask", price: 800, description: "A richer mask treatment for deep hydration. Helps to restore moisture and softness, especially useful for dry, porous or stressed hair." },
  { id: 8, title: "Matrix Food For Soft Multi Use Hair Oil Serum 50ml", image: productImages[7], alt: "Matrix Food For Soft Multi Use Hair Oil Serum", price: 420, description: "A leave-in oil serum to seal in moisture, add shine, and help protect hair (including from heat). Can be used on damp or dry." },
  { id: 9, title: "Mizani Press Agent Thermal Smoothing Shampoo 250ml", image: productImages[8], alt: "Mizani Press Agent Thermal Smoothing Shampoo", price: 440, description: "Lightweight shampoo that preps and protects hair for thermal styling, detangles & helps achieve sleek blow-outs / silk presses." },
  { id: 10, title: "Mizani Press Agent Thermal Smoothing Conditioner 250ml", image: productImages[9], alt: "Mizani Press Agent Thermal Smoothing Conditioner", price: 460, description: "Creamy conditioner that moisturises frizzy/dry hair, detangles, and helps lock in moisture for heat styling." },
  { id: 11, title: "Mizani Press Agent Raincoat Cream", image: productImages[10], alt: "Mizani Press Agent Raincoat Cream", price: 0, description: "A layerable heat-protectant smoothing cream; works with the Serum to customise protection and sleekness." },
  { id: 12, title: "Mizani Press Agent Raincoat Serum 100ml", image: "https://www.cosmetology.co.za/wp-content/uploads/2022/03/Mizani-Press-Agent-Raincoat-Styling-Serum-1.jpg", alt: "Mizani Press Agent Raincoat Serum", price: 390, description: "Styling serum that smooths cuticle, controls fly-aways & frizz, adds moisture, protects from heat." },
  { id: 13, title: "Mizani True Textures Coil Stretch Cream 250ml", image: productImages[11], alt: "Mizani True Textures Coil Stretch Cream", price: 490, description: "Cream that elongates, defines and shapes coils; soft-hold finish." },
  { id: 14, title: "Mizani True Textures Curl Defining Pudding 250ml", image: productImages[12], alt: "Mizani True Textures Curl Defining Pudding", price: 490, description: "Lightly-weighted cream/pudding that defines curls/coils, leaves shine, reduces frizz without crunch." },
  { id: 15, title: "Mizani True Textures Sleek Holding Gel 250ml", image: productImages[13], alt: "Mizani True Textures Sleek Holding Gel", price: 490, description: "Flexible high-hold gel for styling (slicked looks, edges, up-dos), without flaking." },
  { id: 16, title: "Mizani True Textures Perfect Coil Gel 325ml", image: "https://www.retailbox.co.za/cdn/shop/files/MIZANI-true-textures-perfect-coil-oil-gel.jpg?v=1741763705", alt: "Mizani True Textures Perfect Coil Gel", price: 360, description: "Curl activator gel for coily / tight textures; defines and enhances curl pattern." },
  { id: 17, title: "Mizani 25 Miracle Milk Leave-In Conditioner 250ml", image: productImages[15], alt: "Mizani 25 Miracle Milk Leave-In Conditioner", price: 430, description: "Lightweight leave-in that nourishes, detangles, protects; many 'miracle' benefits." },
  { id: 18, title: "Mizani 25 Miracle Milk Leave-In Conditioner 400ml", image: productImages[16], alt: "Mizani 25 Miracle Milk Leave-In Conditioner", price: 520, description: "Lightweight leave-in that nourishes, detangles, protects; many 'miracle' benefits." },
  { id: 19, title: "Mizani 25 Miracle Nourishing Hair Oil 125ml", image: productImages[18], alt: "Mizani 25 Miracle Nourishing Hair Oil", price: 430, description: "Multitasking hair oil to moisturise, add shine, fight frizz." },
  { id: 20, title: "Mizani Coconut Soufflé Hairdress", image: "https://slimages.macysassets.com/is/image/MCY/products/4/optimized/9333644_fpx.tif?op_sharpen=1&wid=700&hei=855&fit=fit,1", alt: "Mizani Coconut Soufflé Hairdress", price: 0, description: "Weightless moisturiser / hairdress for natural hair; lightweight hydration and breakage protection." },
  { id: 21, title: "Mizani Strength Fusion Intense Night Treatment 150ml", image: productImages[17], alt: "Mizani Strength Fusion Intense Night Treatment 150ml", price: 440, description: "Overnight mask/treatment for repair, strengthening of dry or damaged hair." },
  { id: 22, title: "Mizani Rose H2O Conditioning Hairdress", image: "https://www.wigtypes.com/cdn/shop/products/mizani-rose-h2o-conditioning-hairdress-8oz-200515032945.jpg?v=1691706010", alt: "Mizani Rose H2O Conditioning Hairdress", price: 0, description: "Creamy leave-in hairdress with botanicals to hydrate and soothe hair & scalp." },
  { id: 23, title: "Mizani Scalp Calming Lotion Leave-In Scalp Moisturiser Treatment 120ml", image: productImages[18], alt: "Mizani Scalp Calming Lotion Leave-In Scalp Moisturiser Treatment 120ml", price: 340, description: "For soothing scalp (itch, irritation) while also moisturising." },
  { id: 24, title: "Mizani Miracle Length Hairline & Root Stimulator 90ml", image: "https://cdn.shopify.com/s/files/1/0082/2191/7266/products/Mizani-Miracle-Lengths-serum-90ml_2048x2048.jpg?v=1565027700", alt: "Mizani Miracle Length Hairline & Root Stimulator 90ml", price: 800, description: "A lightweight scalp serum that stimulates and strengthens the hairline and roots to encourage healthy growth, reduce breakage, and soothe tension-prone areas." },
  { id: 25, title: "Mizani Butter Blend Relaxer 4-Pack", image: productImages[20], alt: "Mizani Butter Blend Relaxer 4-Pack", price: 1200, description: "Four tubs of professional-strength relaxer enriched with shea and cocoa butter for smooth, soft, and manageable hair. Perfect for salons or multiple applications, leaving hair shiny and frizz-free." },
  { id: 26, title: "Mizani Butter Blend Relaxer (1816g)", image: productImages[19], alt: "Mizani Butter Blend Relaxer (1816g)", price: 1100, description: "Professional-strength straightening with shea and cocoa butter for smooth, soft, and manageable hair. Gentle enough for all textures, leaving hair shiny and frizz-free." }
];

const Products = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const preview = products.slice(0, 8);

  return (
    <section id="products" style={{ background: "#f8f6ef" }} className="py-5">
      <div className="container">
        <h2
          className="text-center fw-bold mb-2"
          style={{
            color: '#2c2c2c',
            fontFamily: "'Playfair Display',serif",
            letterSpacing: '.025em',
            fontSize: "1.28rem"
          }}
        >
          Premium Hair Products
        </h2>
        <p
          className="text-center text-muted mb-3"
          style={{
            fontWeight: 400,
            fontSize: ".97rem",
            maxWidth: 450,
            margin: "0 auto"
          }}
        >
          Maintain salon-style perfection between visits with our professional-grade hair care collection.
        </p>

        {/* 4 columns on all breakpoints */}
        <div
          className="row g-1 justify-content-center"
          style={{ rowGap: '0.55rem', columnGap: '0.2rem' }}
        >
          {preview.map(product => (
            <div
              key={product.id}
              className="col-3 d-flex flex-column align-items-center"
              style={{
                minWidth: 0,
                padding: 0,
                margin: '0 auto'
              }}
            >
              <div
                className="w-100"
                style={{
                  background: "#fff",
                  borderRadius: 8,
                  boxShadow: "0 2px 7px #cab38a19",
                  padding: "0.5rem 0.45rem 0.35rem 0.45rem",
                  transition: "transform .16s, box-shadow .18s",
                  height: "100%"
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: 70,
                    borderRadius: 6,
                    overflow: "hidden",
                    background: "#f3e7ce",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 6
                  }}
                >
                  <img
                    src={product.image}
                    alt={product.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                      background: "white"
                    }}
                    onError={e => {
                      if (!e.target.dataset.fallback) {
                        e.target.dataset.fallback = "true";
                        e.target.src = "/placeholder-image.jpg";
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    fontSize: ".8em",
                    color: "#332b16",
                    fontWeight: 700,
                    fontFamily: "Inter,sans-serif",
                    marginBottom: 3,
                    textAlign: "center",
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {product.title}
                </div>
                <div
                  style={{
                    fontSize: ".72em",
                    color: "#87744f",
                    textAlign: "center",
                    marginBottom: 2,
                    maxHeight: 34,
                    overflow: "hidden"
                  }}
                >
                  {product.description}
                </div>
                <div
                  style={{
                    color: "#2c2c2c",
                    fontWeight: 700,
                    fontSize: ".8em",
                    textAlign: "center",
                    marginBottom: 4
                  }}
                >
                  {product.price > 0 ? (
                    <>R {product.price}</>
                  ) : (
                    <span className="text-danger fs-6 fw-normal">Unavailable</span>
                  )}
                </div>
                <button
                  className="btn rounded-pill w-100 fw-bold mb-1"
                  style={{
                    background:
                      product.price > 0
                        ? "linear-gradient(90deg,#c4a15a,#d4c4a8)"
                        : "#ddd",
                    color: product.price > 0 ? "#fff" : "#999",
                    fontSize: ".75em",
                    border: "none",
                    fontFamily: "Inter,sans-serif",
                    letterSpacing: ".01em",
                    cursor: product.price > 0 ? "pointer" : "not-allowed",
                    minHeight: 26,
                    padding: "4px 6px"
                  }}
                  disabled={product.price === 0}
                  onClick={() => addToCart(product.id)}
                >
                  {product.price === 0 ? "Unavailable" : "Add"}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <button
            className="btn rounded-pill fw-bold"
            style={{
              background: 'linear-gradient(90deg, #c4a15a, #d4c4a8)',
              color: '#fff',
              fontSize: ".96rem",
              border: "none",
              padding: "9px 36px",
              fontFamily: "Inter,sans-serif"
            }}
            onClick={() => navigate('/all-products')}
          >
            View All Products
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;

